import { FindCategoriesToOfflineOutput } from '../../../../../../../../../services/modules/categories/categories.types';
import { OfflineDatabaseCategory } from '../../../../../../../database/offlineDatabase/types/offlineDatabaseCategory.types';
import { offlineCategoriesRepository } from '../../../../../../../repositories/offlineCategories.repository';
import { QueryKeysAndFnOptions } from '../../../useQueryKeysAndFnToCache.types';
import { generateQueryKeysAndFnToPaginatedEndpoint } from '../../generateQueryKeysAndFnToPaginatedEndpoint';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './types';

export class CategoriesQueryKeysAndFnGenerator implements QueryKeysAndFnGenerator {
  constructor(private readonly params: Pick<QueryKeysAndFnGeneratorParams, 'priority'>) {}

  async generateQueryKeysAndFn(): Promise<QueryKeysAndFnOptions> {
    return generateQueryKeysAndFnToPaginatedEndpoint<FindCategoriesToOfflineOutput>({
      url: '/categories/offline/v1',
      priority: this.params.priority,
      fnToSaveData: async (data) => {
        await offlineCategoriesRepository.saveAll(data.map(this.toOfflineData));
      },
    });
  }

  private toOfflineData(data: FindCategoriesToOfflineOutput): OfflineDatabaseCategory {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
      groupId: data.parent?.id ?? null,
      groupName: data.parent?.name ?? null,
    };
  }
}
